/*
 * Public API Surface of avatar
 */

export * from './lib/avatar.service';
export * from './lib/avatar.component';
export * from './lib/avatar.module';
export * from './lib/avatar.enum';
